export const ServiceKey = "Authentication";
